/* eslint-disable no-unused-expressions */
/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import $ from 'jquery';
import { Link } from 'react-router-dom';

class PartnerProductCatagory extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    $(".citizen-footer-note").css("display", "none");
  }
  render() {
    const { PartnerDetailPageResponse, } = this.props;
    const { categories } = PartnerDetailPageResponse;

    return (
      <div className="container product-categories-container">
        <div className="row">
          <div className="card-deck product-categories-card-deck">
            {this.props && (categories.ACCOUNTING && categories.ADMISSIONS && (categories.BUSINESS_SKILLS || categories.TECHNOLOGY) && categories.FINANCE) && (
              <div className="col-xs-12 col-md-4">
                {this.props && categories.ACCOUNTING && (
                  <div className="card product-categories-cards">
                    <div className="card-header">ACCOUNTING</div>
                    <div className="card-body">
                      <div className="card-text">
                        <dl className="product-categories-options">
                          {this.props && categories.ACCOUNTING && categories.ACCOUNTING.map((item) => (
                            <React.Fragment key={item}>
                              <dt>
                                <span className="fa fa-circle product-categories-options-icons" />
                              </dt>
                              <dd><Link to={`/partner/${this.props.match.params.partnerId}/${this.props.match.params.partnerId}-${item.replace(/ /g, "-").toLowerCase()}`}>{item}</Link></dd>
                            </React.Fragment>
                          ))}
                        </dl>
                      </div>
                    </div>
                  </div>
                )}
                {this.props && categories.ADMISSIONS && (
                  <div className="card product-categories-cards">
                    <div className="card-header">ADMISSIONS</div>
                    <div className="card-body">
                      <div className="card-text">
                        <dl className="product-categories-options">
                          {this.props && categories.ADMISSIONS && categories.ADMISSIONS.map((item) => (
                            <React.Fragment key={item}>
                              <dt>
                                <span className="fa fa-circle product-categories-options-icons" />
                              </dt>
                              <dd><Link to={`/partner/${this.props.match.params.partnerId}/${this.props.match.params.partnerId}-${item.replace(/ /g, "-").toLowerCase()}`}>{item}</Link></dd>
                            </React.Fragment>
                          ))}
                        </dl>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}

            {this.props && categories.ACCOUNTING && !(categories.ADMISSIONS && (categories.BUSINESS_SKILLS || categories.TECHNOLOGY) && categories.FINANCE) && (
              <div className="col-xs-12 col-md-4">
                <div className="card product-categories-cards">
                  <div className="card-header">ACCOUNTING</div>
                  <div className="card-body">
                    <div className="card-text">
                      <dl className="product-categories-options">
                        {this.props && categories.ACCOUNTING && categories.ACCOUNTING.map((item) => (
                          <React.Fragment key={item}>
                            <dt>
                              <span className="fa fa-circle product-categories-options-icons" />
                            </dt>
                            <dd><Link to={`/partner/${this.props.match.params.partnerId}/${this.props.match.params.partnerId}-${item.replace(/ /g, "-").toLowerCase()}`}>{item}</Link></dd>
                          </React.Fragment>
                        ))}
                      </dl>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {this.props && categories.ADMISSIONS && !(categories.ACCOUNTING && (categories.BUSINESS_SKILLS || categories.TECHNOLOGY) && categories.FINANCE) && (
              <div className="col-xs-12 col-md-4">
                <div className="card product-categories-cards">
                  <div className="card-header">ADMISSIONS</div>
                  <div className="card-body">
                    <div className="card-text">
                      <dl className="product-categories-options">
                        {this.props && categories.ADMISSIONS && categories.ADMISSIONS.map((item) => (
                          <React.Fragment key={item}>
                            <dt>
                              <span className="fa fa-circle product-categories-options-icons" />
                            </dt>
                            <dd><Link to={`/partner/${this.props.match.params.partnerId}/${this.props.match.params.partnerId}-${item.replace(/ /g, "-").toLowerCase()}`}>{item}</Link></dd>
                          </React.Fragment>
                        ))}
                      </dl>
                    </div>
                  </div>
                </div>
              </div>
            )}


            {this.props && ((categories.ACCOUNTING || categories.ADMISSIONS) && categories.BUSINESS_SKILLS && categories.TECHNOLOGY && categories.FINANCE) && (
              <div className="col-xs-12 col-md-4">
                {this.props && categories.BUSINESS_SKILLS && (
                  <div className="card product-categories-cards">
                    <div className="card-header">BUSINESS SKILLS</div>
                    <div className="card-body">
                      <div className="card-text">
                        <dl className="product-categories-options">
                          {this.props && categories.BUSINESS_SKILLS && categories.BUSINESS_SKILLS.map((item) => (
                            <React.Fragment key={item}>
                              <dt>
                                <span className="fa fa-circle product-categories-options-icons" />
                              </dt>
                              <dd><Link to={`/partner/${this.props.match.params.partnerId}/${this.props.match.params.partnerId}-${item.replace(/ /g, "-").toLowerCase()}`}>{item}</Link></dd>
                            </React.Fragment>
                          ))}
                        </dl>
                      </div>
                    </div>
                  </div>
                )}
                {this.props && categories.TECHNOLOGY && (
                  <div className="card product-categories-cards">
                    <div className="card-header">TECHNOLOGY</div>
                    <div className="card-body">
                      <div className="card-text">
                        <dl className="product-categories-options">
                          {this.props && categories.TECHNOLOGY && categories.TECHNOLOGY.map((item) => (
                            <React.Fragment key={item}>
                              <dt>
                                <span className="fa fa-circle product-categories-options-icons" />
                              </dt>
                              <dd><Link to={`/partner/${this.props.match.params.partnerId}/${this.props.match.params.partnerId}-${item.replace(/ /g, "-").toLowerCase()}`}>{item}</Link></dd>
                            </React.Fragment>
                          ))}
                        </dl>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}

            {this.props && categories.BUSINESS_SKILLS && !((categories.ACCOUNTING || categories.ADMISSIONS) && categories.BUSINESS_SKILLS && categories.TECHNOLOGY && categories.FINANCE) && (
              <div className="col-xs-12 col-md-4">
                <div className="card product-categories-cards">
                  <div className="card-header">BUSINESS SKILLS</div>
                  <div className="card-body">
                    <div className="card-text">
                      <dl className="product-categories-options">
                        {this.props && categories.BUSINESS_SKILLS && categories.BUSINESS_SKILLS.map((item) => (
                          <React.Fragment key={item}>
                            <dt>
                              <span className="fa fa-circle product-categories-options-icons" />
                            </dt>
                            <dd><Link to={`/partner/${this.props.match.params.partnerId}/${this.props.match.params.partnerId}-${item.replace(/ /g, "-").toLowerCase()}`}>{item}</Link></dd>
                          </React.Fragment>
                        ))}
                      </dl>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {this.props && categories.TECHNOLOGY && !((categories.ACCOUNTING || categories.ADMISSIONS) && categories.BUSINESS_SKILLS && categories.TECHNOLOGY && categories.FINANCE) && (
              <div className="col-xs-12 col-md-4">
                <div className="card product-categories-cards">
                  <div className="card-header">TECHNOLOGY</div>
                  <div className="card-body">
                    <div className="card-text">
                      <dl className="product-categories-options">
                        {this.props && categories.TECHNOLOGY && categories.TECHNOLOGY.map((item) => (
                          <React.Fragment key={item}>
                            <dt>
                              <span className="fa fa-circle product-categories-options-icons" />
                            </dt>
                            <dd><Link to={`/partner/${this.props.match.params.partnerId}/${this.props.match.params.partnerId}-${item.replace(/ /g, "-").toLowerCase()}`}>{item}</Link></dd>
                          </React.Fragment>
                        ))}
                      </dl>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {this.props && categories.FINANCE && (
              <div className="col-xs-12 col-md-4">
                <div className="card product-categories-cards">
                  <div className="card-header">FINANCE</div>
                  <div className="card-body">
                    <div className="card-text">
                      <dl className="product-categories-options">
                        {this.props && categories.FINANCE && categories.FINANCE.map((item) => (
                          <React.Fragment key={item}>
                            <dt>
                              <span className="fa fa-circle product-categories-options-icons" />
                            </dt>
                            <dd><Link to={`/partner/${this.props.match.params.partnerId}/${this.props.match.params.partnerId}-${item.replace(/ /g, "-").toLowerCase()}`}>{item}</Link></dd>
                          </React.Fragment>
                        ))}
                      </dl>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default PartnerProductCatagory;
